type SingleAttr<T> = {
  data: T;
};

type SingleArrayAttr<T> = SingleAttr<Array<T>>;

type PageAttr<T> = SingleArrayAttr<T> & {
  pagination: {
    count: number;
    limit: number;
    page: number;
  };
};

enum OrderTypes {
  DESC = "DESC",
  ASC = "ASC",
}

type StatusErrorResponse = {
  code: string;
  error: boolean;
  message: string;
};

enum SortByType {
  ORDER_NUMBER = "order_number",
  SHIP_DATE = "ship_date",
  CHANGE_DATE = "change_date",
  CARRIER_NAME = "carrier_name",
  DELIVERY_DATE = "delivery_date",
  CARRIER_ID = "carrier_id",
  POSTED_DATE = "posted_date",
  CREATED_AT = "created_at",
  POSTED_BY = "posted_by",
  STATUS = "status",
  RATE = "rate",
  APPROVER_NAME = "approver_name",
}

type SortByValuesType = {
  sort_by: SortByType;
  order_by: OrderTypes;
};

export { OrderTypes, SortByType };
export type {
  PageAttr,
  SortByValuesType,
  StatusErrorResponse,
  SingleAttr,
  SingleArrayAttr,
};
